import store from '..'
import * as types from '../mutation-types'
import { parseExpenseEntries, buildExpenseNotes } from '@/helpers/employee-stock-expenses'

export default {
	namespaced: true,
	state: {
		stock: null
	},

	actions: {
		fetchByDate({ commit }, { date }) {
			return window.axios.get('/employeeStock/byDate', {
				params: { employeeId: store.state.auth.self.employeeId, date }
			}).then(({ data }) => {
				commit(types.STORE_EMPLOYEE_STOCK, data || null)
				return data
			})
		},

		addExpense({ dispatch }, { date, name, amount }) {
			return window.axios.put('/employeeStock/addExpense/currentStock', {
				amount,
				note: { key: name, value: String(amount) }
			}).then(() => dispatch('fetchByDate', { date }))
		},

		// shared by Edit (replace one entry) and Delete (filter one entry out) - both
		// rebuild the whole notes array since AddExpense can only append, never rewrite
		updateExpenses({ commit, state }, { entries }) {
			const { foreignItems } = parseExpenseEntries(state.stock.notes)
			const notes = buildExpenseNotes({ entries, foreignItems })
			const expenses = entries.reduce((sum, entry) => sum + (Number(entry.amount) || 0), 0)

			return window.axios.put(`/employeeStock/${state.stock.id}`, {
				employeeId: state.stock.employeeId,
				date: state.stock.date,
				amountDelivered: state.stock.amountDelivered,
				amountReceived: state.stock.amountReceived,
				amountReturnedForCustomers: state.stock.amountReturnedForCustomers,
				isPosted: state.stock.isPosted,
				notes,
				expenses
			}).then(() => {
				commit(types.STORE_EMPLOYEE_STOCK, { ...state.stock, notes, expenses })
			})
		},

		delete({ dispatch, getters }, { id }) {
			return dispatch('updateExpenses', {
				entries: getters.getExpenseEntries.filter(entry => entry.id !== id)
			})
		},

		reset({ commit }) {
			commit(types.RESET_EMPLOYEE_STOCK)
		}
	},

	mutations: {
		[types.STORE_EMPLOYEE_STOCK](state, stock) {
			state.stock = stock
		},

		[types.RESET_EMPLOYEE_STOCK](state) {
			state.stock = null
		}
	},

	getters: {
		getExpenseEntries: state => state.stock ? parseExpenseEntries(state.stock.notes).entries : []
	}
}
